import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { GROUP_SUBSCRIPTION_TEAM } from '@src/constants';
import {
  CreateTeamSubscriptionsParams,
  GROUP_SUBSCRIPTION_KEY,
  createTeamSubscriptions,
} from '@utils/backend-api/groupSubscriptions';
import { TeamResponse } from '@utils/backend-api/teams';

export default function useTeamSubscriptionsCreate() {
  const queryClient = useQueryClient();
  const { mutate, mutateAsync, isLoading } = useMutation(
    (values: CreateTeamSubscriptionsParams) => {
      return createTeamSubscriptions(values);
    },
    {
      onSuccess: (data: TeamResponse) => {
        if (data.success) {
          toast.success('Team members were added.');
          queryClient.invalidateQueries([GROUP_SUBSCRIPTION_KEY, GROUP_SUBSCRIPTION_TEAM]);
        }
      },
      onError: (e) => {
        console.error(e);
        toast.error('Team members were not added, please try again.');
      },
    }
  );

  return {
    addTeamSubscriptions: mutate,
    addTeamSubscriptionsAsync: mutateAsync,
    isAddTeamSubscriptionsLoading: isLoading,
  };
}
